module.exports = __webpack_public_path__ + "static/media/house1.df55f8ed.png";